/**
 * Customer-console users: which applications they may open (in addition to organizationRole permissions).
 * Stored as JSON on User.applicationScope.
 */

/**
 * @param {unknown} scope
 * @returns {{ type: 'all' } | { type: 'apps'; applicationIds: number[] }}
 */
export function normalizeApplicationScope(scope) {
  if (!scope || typeof scope !== 'object') {
    return { type: 'all' };
  }
  const type = scope.type;
  if (type === 'apps' && Array.isArray(scope.applicationIds) && scope.applicationIds.length > 0) {
    const ids = [...new Set(scope.applicationIds.map(Number).filter((n) => Number.isInteger(n) && n > 0))];
    if (ids.length === 0) {
      return { type: 'all' };
    }
    return { type: 'apps', applicationIds: ids };
  }
  return { type: 'all' };
}

/**
 * @param {{ organizationRole?: string, applicationScope?: unknown }} user — auth user or API row
 * @param {number} applicationId
 */
export function userHasApplicationAccess(user, applicationId) {
  if (!user) {
    return false;
  }
  if (user.organizationRole === 'customer_admin') {
    return true;
  }
  const scope = normalizeApplicationScope(user.applicationScope);
  if (scope.type === 'all') {
    return true;
  }
  return scope.applicationIds.includes(Number(applicationId));
}

/**
 * @param {unknown} scope
 * @param {{ id: number, name?: string }[]} [applications] — optional names for labels
 */
export function formatApplicationScopeLabel(scope, applications = []) {
  const s = normalizeApplicationScope(scope);
  if (s.type === 'all') {
    return 'All applications';
  }
  const ids = s.applicationIds;
  const resolveName = (id) => {
    const app = applications.find((a) => a.id === id);
    return app?.name ? app.name : `App #${id}`;
  };
  if (ids.length <= 3) {
    return ids.map(resolveName).join(', ');
  }
  return `${ids.length} applications`;
}
